import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import LogBg from "../../../containers/modules/accounting/log-bg";

export default function LogBgRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="log-bg"
      index
      element={
        <AccessControl
          name={"Log BG List"}
          auth={authUser}
          component={() => <LogBg />}
        />
      }
    />
  );
}
